import { DASHBOARD_TABS } from "../../../config/tabConstants"
import { URL_DATA } from "../../../config/urlDataConstants"
import { getURLFilterAndByScore } from "../../utils/byScoreFilterUtils"
import { deepCopy } from "../../utils/deepCopy"
import { getDataFromUrlToken } from "../../utils/urlDataStore"
import { DISENGAGEMENT_SUB_CARD, ELEMENTS, ENGAGEMENT_SUB_CARD, FILTER_TYPE, GOING_WELL_SUB_CARD, IMPROVEMENT_SUB_CARD, NEGATIVE_SUB_CARD, POSITIVE_SUB_CARD, SUB_STORY_CARD } from "./constants"
import { getSelectedUserData } from "./subroutes/Explore/helper"

export const modifyPayloadForSubCard=(payload,cardDetails)=>{
 let modifiedPayload=deepCopy(payload)
  if (cardDetails.filterType) {
    cardDetails.filterType.forEach((filter) => {
      modifiedPayload[filter] = Array.isArray(modifiedPayload[filter]) ? [...cardDetails.details[filter], ...modifiedPayload[filter]] : { ...cardDetails.details[filter], ...modifiedPayload[filter] }
    })
  }
 modifiedPayload.currentId=cardDetails.currentId
 modifiedPayload.prompt=cardDetails.details.prompt
 return modifiedPayload
}

export const generateSubcardsData = ({ tabsList, payload, projectData }) => {
    let multiplePayloadsForSubcards = []
    const selectedUserData = getSelectedUserData();
    const urlFilter = getDataFromUrlToken(URL_DATA.DASHBOARD_FILTER) || {};
    const filterData = getURLFilterAndByScore(urlFilter);
    const updatedPayload = {
      ...payload,
      currentTab: DASHBOARD_TABS.STORYBOARD,
      ...filterData,
      hrisFileId: projectData.hrisFileId,
      directReporteesOnly: selectedUserData.directReporteesOnly,
      selectedUser: selectedUserData.selectedUser,
      topicsFilter: []
    };

    if (tabsList.some((item) => item.elementId === SUB_STORY_CARD.WHY_VERY_ENGAGED)) {
      let engagementData = ENGAGEMENT_SUB_CARD
      let engagementCardDetails = tabsList.find((item) => item.elementId === SUB_STORY_CARD.WHY_VERY_ENGAGED)
      if (engagementCardDetails.outlierElement) {
        engagementData.filters = {
          [engagementCardDetails.outlierElement.type]: [engagementCardDetails.outlierElement.segment],
        }
      }

      multiplePayloadsForSubcards.push(modifyPayloadForSubCard(updatedPayload, { details: engagementData, currentId: SUB_STORY_CARD.WHY_VERY_ENGAGED, filterType: [FILTER_TYPE.BY_SCORE, FILTER_TYPE.FILTER] }))
    }
    if (tabsList.some((item) => item.elementId === SUB_STORY_CARD.WHY_VERY_DISENGAGED)) {
      let disengagedData = DISENGAGEMENT_SUB_CARD
      let disengagementCardDetails = tabsList.find((item) => item.elementId === SUB_STORY_CARD.WHY_VERY_DISENGAGED)
      if (disengagementCardDetails.outlierElement) {
        disengagedData.filters = {
          [disengagementCardDetails.outlierElement.type]: [disengagementCardDetails.outlierElement.segment],
        }
      }

      multiplePayloadsForSubcards.push(modifyPayloadForSubCard(updatedPayload, { details: disengagedData, currentId: SUB_STORY_CARD.WHY_VERY_DISENGAGED, filterType: [FILTER_TYPE.BY_SCORE, FILTER_TYPE.FILTER], }))
    }
    if (tabsList.some((item) => item.elementId === SUB_STORY_CARD.WHY_VERY_POSITIVE)) {
      let positiveDetails = POSITIVE_SUB_CARD
      let findedPositiveItem = tabsList.find((element) => element.elementId === ELEMENTS.POSITIVE_OUTCOME_OUTLIER)

      if (findedPositiveItem) {
        positiveDetails.filters = {
          [findedPositiveItem.demograhic]: [findedPositiveItem.segment],
        }
        multiplePayloadsForSubcards.push(modifyPayloadForSubCard(updatedPayload, { details: positiveDetails, currentId: SUB_STORY_CARD.WHY_VERY_POSITIVE, filterType: [FILTER_TYPE.FILTER] }))

      }
    }
    if (tabsList.some((item) => item.elementId === SUB_STORY_CARD.WHY_VERY_NEGATIVE)) {
      let negativeDetails = NEGATIVE_SUB_CARD
      let findedNegativeItem = tabsList.find((element) => element.elementId === ELEMENTS.NEGATIVE_OUTCOME_OUTLIER)

      if (findedNegativeItem) {
        negativeDetails.filters = {
          [findedNegativeItem.demograhic]: [findedNegativeItem.segment],
        }
        multiplePayloadsForSubcards.push(modifyPayloadForSubCard(updatedPayload, { details: negativeDetails, currentId: SUB_STORY_CARD.WHY_VERY_NEGATIVE, filterType: [FILTER_TYPE.FILTER] }))

    }
  }
  if (tabsList.some((item) => item.elementId === SUB_STORY_CARD.WHAT_CAN_BE_IMPROVED_REASON)) {
    let improvementData = IMPROVEMENT_SUB_CARD
    let findedImprovementItem = tabsList.find((element) => element.elementId === ELEMENTS.IMPROVEMENT)
    if (findedImprovementItem && findedImprovementItem.topics && findedImprovementItem.topics.length > 0) {
      improvementData.topicsFilter = [findedImprovementItem.topics[0].name]
      multiplePayloadsForSubcards.push(modifyPayloadForSubCard(updatedPayload, { details: improvementData, currentId: SUB_STORY_CARD.WHAT_CAN_BE_IMPROVED_REASON, filterType: [FILTER_TYPE.TOPICS_FILTER] }))
    }
  }
  if (tabsList.some((item) => item.elementId === SUB_STORY_CARD.WHAT_IS_GOING_WELL_REASON)) {
    let goingWellData = GOING_WELL_SUB_CARD
    let findedGoingWellItem = tabsList.find((element) => element.elementId === ELEMENTS.GOING_WELL)
    if (findedGoingWellItem && findedGoingWellItem.topics && findedGoingWellItem.topics.length > 0) {
      goingWellData.topicsFilter = [findedGoingWellItem.topics[0].name]
      multiplePayloadsForSubcards.push(modifyPayloadForSubCard(updatedPayload, { details: goingWellData, currentId: SUB_STORY_CARD.WHAT_IS_GOING_WELL_REASON, filterType: [FILTER_TYPE.TOPICS_FILTER] }))
      }

    }
    return multiplePayloadsForSubcards
}

